import React, { useEffect, useRef, useState } from 'react';

// Import toàn bộ logic gốc - GIỮ NGUYÊN 100%
import './core/lotteryLogic';
import { loadUsersFromAPI, loadPrizesFromAPI, dataTemp } from './core/const';
import { useTranslation } from 'react-i18next';
import logo from "assets/images/logo.png";


const LotteryPage = () => {
    // Refs để tham chiếu đến các DOM elements
    const canvasRef = useRef(null);
    const musicRef = useRef(null);
    const musicBoxRef = useRef(null);
    const containerRef = useRef(null);
    const prizeBarRef = useRef(null);
    const qipaoContainerRef = useRef(null);
    const menuRef = useRef(null);
    const { t } = useTranslation();


    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Dynamic import CSS chỉ khi component mount
        const loadedStyles = [];

        import('./core/index.css').then(module => {
            if (module.default) loadedStyles.push(module.default);
        });
        import('./css/animate.min.css').then(module => {
            if (module.default) loadedStyles.push(module.default);
        });

        // Load users từ API khi component mount
        const initializeLottery = async () => {
            try {
                console.log('Loading prizes and users from API...');

                // Load prizes first
                const prizeData = await loadPrizesFromAPI();

                // Update dataTemp with prizes from API
                dataTemp.cfgData.prizes = prizeData.prizes;
                dataTemp.cfgData.EACH_COUNT = prizeData.eachCount;
                dataTemp.t = t;

                // Then load users
                const userData = await loadUsersFromAPI();


                // Gọi hàm khởi tạo lottery với dữ liệu users
                if (window.initLotteryWithUsers) {
                    window.initLotteryWithUsers(userData);
                }

                setIsLoading(false);
            } catch (err) {
                console.error('Error initializing lottery:', err);
                setError(err.message);
                setIsLoading(false);
            }
        };

        initializeLottery();

        return () => {
            // Cleanup: Remove dynamically loaded CSS
            const styleSheets = Array.from(document.styleSheets);
            styleSheets.forEach(sheet => {
                if (sheet.href && (
                    sheet.href.includes('index.css') ||
                    sheet.href.includes('animate.min.css')
                )) {
                    sheet.disabled = true;
                }
            });

            // Remove inline styles if any
            const inlineStyles = document.querySelectorAll('style[data-lottery]');
            inlineStyles.forEach(style => style.remove());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="lottery-container">
            {isLoading && (
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999,
                    color: 'white',
                    fontSize: '24px',
                    textAlign: 'center'
                }}>
                    Loading
                </div>
            )}

            {error && (
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999,
                    color: 'red',
                    fontSize: '24px',
                    textAlign: 'center'
                }}>
                    Lỗi: {error}
                </div>
            )}

            {/* Logo with animation */}
            <div style={{
                position: 'fixed',
                top: '0',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1000,
                animation: 'logoFloat 3s ease-in-out infinite'
            }}>
                <img
                    src={logo}
                    alt="EAT HAPPY Logo"
                    style={{
                        maxWidth: '300px',
                        height: 'auto',
                        filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))',
                        animation: 'logoPulse 2s ease-in-out infinite'
                    }}
                    onError={(e) => {
                        e.target.style.display = 'none';
                        console.warn('Logo not found at public/img/logo.png');
                    }}
                />
            </div>

            <style>
                {`
                    @keyframes logoFloat {
                        0%, 100% { transform: translateX(-50%) translateY(0px); }
                        50% { transform: translateX(-50%) translateY(-10px); }
                    }
                    
                    @keyframes logoPulse {
                        0%, 100% { transform: scale(1); }
                        50% { transform: scale(1.05); }
                    }
                `}
            </style>

            <div className="canvas-box">
                <canvas id="canvas" ref={canvasRef}>
                    Your browser does not support canvas
                </canvas>
            </div>

            <div className="music">
                <audio
                    id="music"
                    ref={musicRef}
                    src={`${process.env.PUBLIC_URL}/music.mp3`}
                    className="music-item"
                    loop
                />
                <div
                    id="musicBox"
                    ref={musicBoxRef}
                    className="music-box"
                    title="Phát/Tạm dừng nhạc nền"
                >
                    Music
                </div>
            </div>

            <div id="prizeBar" ref={prizeBarRef}></div>

            <div id="container" ref={containerRef}></div>

            <div id="menu" ref={menuRef}>
                <button id="enter">{t('enterLuckyDraw')}</button>
                <div id="lotteryBar" className="none">
                    <button id="lottery">{t('startSpin')}</button>
                    <button id="reLottery">{t('back')}</button>
                    <div className="fixed-bar">
                        <button id="save" className="fixed-btn">{t('exportExcel')}</button>
                        <button id="reset" className="fixed-btn">{t('reset')}</button>
                    </div>
                </div>
            </div>

            <div className="qipao-container" ref={qipaoContainerRef}></div>
        </div>
    );
};

export default LotteryPage;
